import React from 'react';
import { useContent } from '../../context/ContentContext';
import {
  DEFAULT_HOME_SERMONS_MORE_LINK,
  resolveHomeSermons,
} from '../../data/homeSermons';

export default function EditorPanelSermonsDetail() {
  const { getContent, setContentValue } = useContent();
  const sermons = resolveHomeSermons(getContent);
  const moreLink = getContent('home.sermons.moreLink', DEFAULT_HOME_SERMONS_MORE_LINK);

  const saveSermons = (nextSermons) => {
    setContentValue('home.sermons.items', nextSermons);
  };

  const updateSermon = (index, patch) => {
    saveSermons(sermons.map((sermon, idx) => (idx === index ? { ...sermon, ...patch } : sermon)));
  };

  return (
    <div className="editor-panel__detail" onClick={(e) => e.stopPropagation()}>
      <p className="editor-panel__detail-lead">Edit each sermon&apos;s links below. Changes save automatically.</p>

      <ul className="editor-panel__detail-list">
        {sermons.map((sermon, index) => (
          <li key={`sermon-${index}`} className="editor-panel__detail-card">
            <div className="editor-panel__detail-card-head">
              <div className="editor-panel__detail-thumb-wrap">
                {sermon.thumbnail ? (
                  <img src={sermon.thumbnail} alt="" className="editor-panel__detail-thumb" />
                ) : (
                  <span className="editor-panel__detail-thumb-placeholder" aria-hidden="true" />
                )}
              </div>
              <span className="editor-panel__detail-card-title">Sermon {index + 1}</span>
            </div>

            <label className="editor-panel__detail-label" htmlFor={`sermon-${index}-video-url`}>
              YouTube URL
            </label>
            <input
              id={`sermon-${index}-video-url`}
              type="url"
              className="editor-panel__detail-input"
              value={sermon.url}
              placeholder="https://www.youtube.com/watch?v=..."
              onChange={(e) => updateSermon(index, { url: e.target.value })}
            />

            <label className="editor-panel__detail-label" htmlFor={`sermon-${index}-thumb-url`}>
              Thumbnail image URL
            </label>
            <input
              id={`sermon-${index}-thumb-url`}
              type="url"
              className="editor-panel__detail-input"
              value={sermon.thumbnail}
              placeholder="https://img.youtube.com/vi/.../hqdefault.jpg"
              onChange={(e) => updateSermon(index, { thumbnail: e.target.value })}
            />
          </li>
        ))}
      </ul>

      <div className="editor-panel__detail-card editor-panel__detail-card--footer">
        <label className="editor-panel__detail-label" htmlFor="sermon-more-link">
          View more button link
        </label>
        <input
          id="sermon-more-link"
          type="url"
          className="editor-panel__detail-input"
          value={moreLink}
          placeholder="https://www.youtube.com/@..."
          onChange={(e) => setContentValue('home.sermons.moreLink', e.target.value)}
        />
      </div>
    </div>
  );
}
